import { render, staticRenderFns } from "./appSidebar.vue?vue&type=template&id=09213349&scoped=true&"
import script from "./appSidebar.vue?vue&type=script&lang=js&"
export * from "./appSidebar.vue?vue&type=script&lang=js&"
import style0 from "./appSidebar.vue?vue&type=style&index=0&id=09213349&scoped=true&lang=css&"
import style1 from "./appSidebar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09213349",
  null
  
)

export default component.exports